<style scoped>
.pub-list .el-table__header-wrapper {
  display: block !important;
  overflow: initial !important;
}

.el-main {
}

.el-button--text {
  background: white;
}

/* .el-button--text:hover {
    background: white;
} */

.notes-box {
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  padding: 6px 6px 6px 6px;
  border-radius: 50%;
}

/* .notes-box:hover {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 6px 6px 6px 6px;
    border-radius: 50%;
} */

.box-header .box-title {
  display: inline-block;
  font-size: 15px;
  padding: 10px;
  line-height: 1;
  color: black;
}

.content-wrapper .content {
  padding-top: 95px !important;
}

.notes-domain {
  line-height: 1;
  display: block;
}

.slide-fade-enter-active {
  transition: all 3s ease;
}

.slide-fade-leave-active {
  transition: all 8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.shadowBox {
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  padding: 10px;
}

.hiddenFileInput > input {
  height: 50%;
  width: 50;
  opacity: 0;
  cursor: pointer;
}

.hiddenFileInput {
  border: 1px solid #ccc;
  width: 50px;
  height: 50px;
  display: inline-block;
  overflow: hidden;

  /*for the background, optional*/
  background: center center no-repeat;
  background-size: 75% 75%;
  background-image: url(data:image/svg+xml;utf8;base64,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);
}

.round {
  border-radius: 50%;
}

.el-button--primary > span > a {
  color: #fff;
}

.domain-name {
  display: block;
  line-height: 1;
  font-weight: bold;
  color: #444;
  text-align: left;
}

.el-button--info {
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.04) !important;
  padding: 10px;
  background-color: white;
  color: black;
}

/* .el-button--info:hover {
    box-shadow: 0 1px 40px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    background-color: white;
    color: black;
} */

.el-table {
  font-size: 13.5px;
}

.publisher-name {
  color: #444;
  font-size: 10px;
  float: left;
  margin-left: 0px;
  padding: 0 10px;
  border-radius: 20px;
  line-height: 1;
  margin-top: 6px;
  text-transform: uppercase;
}

.dfp-network-alias {
  color: #444;
  font-size: 10px;
  float: left;
  margin-left: 0px;
  padding: 0 10px;
  border-radius: 20px;
  line-height: 1;
  margin-top: 6px;
  text-transform: uppercase;
}

.bucket-list {
  display: block;
  padding: 0;
  margin: 0;
  list-style: none;
  white-space: nowrap;
  overflow: auto;
}

.bucket-list li {
  float: left;
  margin-right: 10px;
}

.bucket-list li:last-child {
  margin-right: 0;
}

.forcontract {
  padding: 16px 18px;
  /* background: #6767e2e0;*/
  /* color: white;  */
}

.report-upload-popup button.el-dialog__headerbtn {
  z-index: 2;
}

.colorbtn {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
  border-radius: 4px;
  padding: 10px 27px;
}

.buckets {
  overflow: auto;
}
</style>
<template>
  <div class="content-wrapper">
    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">ALL Publishers</h3>
          <router-link to="/admin/publisher/add" class="el-button el-button--info pull-right">
            <i class="el-icon-plus el-icon-left"></i>
            Create Publisher
          </router-link>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Search</h3>
          <el-input
            type="text"
            class="col-lg-3"
            v-model="searchvalue"
            @keyup.enter.native="filterByEachInput"
            placeholder="Search Any Publisher By Name"
          ></el-input>
        </div>

        <div class="box-body pub-list">
          <el-table
            height="400"
            v-loading="loading"
            :data="publisher"
            style="width: 100%;border-spacing: 0;"
          >
            <el-table-column label="Name" prop="name" width="210">
              <template slot-scope="props">
                <span class="domain-name">{{`${props.row.name}`}}</span>
              </template>
            </el-table-column>
            <el-table-column label="UID" prop="uid" width="110">
              <template slot-scope="props">
                <span>{{`${props.row.uid}`}}</span>
              </template>
            </el-table-column>
            <el-table-column label="Reports" prop="Reports" width="90">
              <template slot-scope="props">
                <el-tooltip content="Reports" placement="bottom">
                  <router-link
                    :to="`${'/admin/publisher/'+props.row.id+'/ReportsRevenue/alldomain'}` "
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style
                  >
                    <i class="fa fa-line-chart" aria-hidden="true"></i>
                  </router-link>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Contract" prop="Contract" width="300" style="font-size:10px">
              <template slot-scope="props">
                <!-- v-if="!props.row.welcome_mail_sent" -->
                <el-tooltip
                  content="Send welcome email"
                  placement="bottom"
                >
                  <button
                    type="success"
                    @click="confirmSendWelcomeEmail(props.row)"
                    class="el-button notes-box el-button--text forcontract"
                    style="background:#33ce33;color:white"
                  >
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                  </button>
                </el-tooltip>
                <!-- <el-tooltip v-else content="Welcome email already sent" placement="bottom">
                  <button
                    type="success"
                    class="el-button notes-box el-button--text forcontract"
                    style="background:rgb(222, 243, 222);color:white;cursor: not-allowed;"
                  >
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                  </button>
                </el-tooltip> -->

                <el-tooltip content="Create Contract" placement="bottom">
                  <router-link
                    :to="`${'/admin/publisher/contract/'+ props.row.id}` "
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:#efb71b;color:white"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </router-link>
                </el-tooltip>
                <el-tooltip content="Upload Signed Contract" placement="bottom">
                  <button
                    type="success"
                    @click="dialogVisiblecontract(props.row.id)"
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:blue;color:white"
                  >
                    <i class="fa fa-upload"></i>
                  </button>
                </el-tooltip>
                <el-tooltip
                  v-if="!props.row.contract_details.sign_pdf"
                  content="Contract not uploaded"
                  placement="bottom"
                >
                  <label
                    :key="props.row.contract_details.sign_pdf"
                    class="el-button notes-box el-button--text el-button--small bg-success forcontract"
                    style="cursor:not-allowed;background:red;color:white"
                  >
                    <i class="fa fa-ban"></i>
                  </label>
                </el-tooltip>
                <el-tooltip v-else content="Download Signed Contract" placement="bottom">
                  <a
                    :href="props.row.contract_details.sign_pdf"
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:#00ced1;color:white"
                  >
                    <i class="fa fa-download"></i>
                  </a>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Tax Form" prop="uuid" width="150">
              <template slot-scope="props">
                <el-tooltip content="Upload Tax form" placement="bottom">
                  <button
                    type="success"
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:blue;color:white"
                    @click="dialogVisiblef(props.row.id)"
                  >
                    <i class="fa fa-upload"></i>
                  </button>
                </el-tooltip>
                <el-tooltip
                  v-if="!props.row.contract_details.tax_pdf"
                  content="Tax form not uploaded"
                  placement="bottom"
                >
                  <label
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="cursor:not-allowed;background:red;color:white"
                  >
                    <i class="fa fa-ban"></i>
                  </label>
                </el-tooltip>
                <el-tooltip v-else content="Download Tax form" placement="bottom">
                  <a
                    :href="props.row.contract_details.tax_pdf"
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:#00ced1;color:white"
                  >
                    <i class="fa fa-download"></i>
                  </a>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Edit" prop="publisher" width="60">
              <template slot-scope="props">
                <el-tooltip content="Edit Publisher" placement="bottom">
                  <button
                    type="success"
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:white;color:black"
                    @click="showEditScreenVisiblefuncton(props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Bank Details" prop="publisher" width="100">
              <template slot-scope="props">
                <el-tooltip content="Copy Bank Details" placement="bottom">
                  <button
                    type="success"
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:white;color:black"
                    @click="showBankInfoScreenVisiblefuncton(props.row)"
                  >
                    <i class="fa fa-bank"></i>
                  </button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Account Activate" prop="publisher" width="90">
              <template slot-scope="props">
                <el-tooltip content="Send Account Activate to Intentt External Publisher" placement="bottom">
                  <button
                    type="success"
                    class="el-button notes-box el-button--text el-button--small forcontract"
                    style="background:white;color:black"
                    @click="confirmIntenttNividEmailSend(props.row)"
                  >
                    <i class="fa fa-envelope"></i>
                  </button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            :visible.sync="EditScreenVisible"
            class="report-upload-popup"
            :before-close="closeEditScreen"
          >
            <template>
              <div>
                <h3>Update Publisher</h3>
              </div>
              <div style="margin:10px 0px">
                <el-input
                  v-validate="'required'"
                  data-vv-delay="1000"
                  :class=" {'input': true , 'is-danger': errors.has('name') }"
                  name="name"
                  type="text"
                  placeholder="15%"
                  v-model="editPubForm.name"
                ></el-input>
                <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
              </div>
              <div style="margin:10px 0px">
                <el-input
                  v-validate="'required'"
                  data-vv-delay="1000"
                  :class=" {'input': true , 'is-danger': errors.has('email') }"
                  name="email"
                  type="text"
                  placeholder="15%"
                  v-model="editPubForm.email"
                ></el-input>
                <span
                  v-show="errors.has('email')"
                  class="help is-danger"
                >{{ errors.first('email') }}</span>
              </div>
              <div style="margin:10px 0px">
                 <span>enable AMP Setup</span>
                <el-switch
                  v-model="editPubForm.amp_ss_enable"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </div>
              <div>
                <el-button type="success" @click="EditPublisher()">Update Publisher</el-button>
              </div>
            </template>
          </el-dialog>

          <el-dialog
            :visible.sync="bankInfoScreenVisible"
            class="report-upload-popup"
            :before-close="closeBankInfoScreen"
          >
            <template>
              <div>
                <h3>Bank Details</h3>
              </div>
              <pre id="divClipboard" style="margin:10px 0">{{bankDetail}}</pre>

              <el-button
                v-if="!iscopied"
                type="success"
                @click="copiedToClipboard()"
              >Copy to clipboard</el-button>
              <button v-else type="button" class="btn btn-primary">Copied</button>
            </template>
          </el-dialog>

          <el-dialog
            :visible.sync="UploadScreenVisible"
            class="report-upload-popup"
            :before-close="clearFilesList"
          >
            <template>
              <el-upload
                v-loading="uploading"
                class="upload-demo m-t-20"
                drag
                :limit="1"
                action="v1/upload-tax-docs/"
                :auto-upload="false"
                :http-request="upload"
                ref="file"
                :file-list="fileList"
                :on-change="handleFileUpload"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Drop file here or
                  <em>click to upload</em>
                </div>
              </el-upload>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelUploadAction">Cancel</el-button>
                <el-button type="success" @click="submitFile()">Upload Tax Form</el-button>
              </span>
            </template>
          </el-dialog>

          <el-dialog
            :visible.sync="contractvisiblescreen"
            class="report-upload-popup"
            :before-close="clearFilesList"
          >
            <template>
              <el-upload
                v-loading="uploading"
                class="upload-demo m-t-20"
                drag
                :limit="1"
                action="v1/upload-contract/"
                :auto-upload="false"
                :http-request="upload"
                ref="file"
                :file-list="fileList"
                :on-change="handleFileUploadcontract"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Drop file here or
                  <em>click to upload</em>
                </div>
              </el-upload>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelUploadAction">Cancel</el-button>
                <el-button type="success" @click="submitcontract()">Upload Contract</el-button>
              </span>
            </template>
          </el-dialog>
          <el-pagination
            style="text-align:center;margin-top:30px"
            @current-change="handleCurrentChange"
            :page-size="offset"
            :pager-count="20"
            layout="prev, pager, next"
            :total="total_pages"
            :current-page.sync="currentPage"
          ></el-pagination>
        </div>
      </div>
    </section>
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import LetterAvatar from "../../../../static/plugins/letterAvatar.js";

export default {
  data() {
    return {
      publisher: [],
      bottom: false,
      frmdata: new FormData(),
      taxFile: "",
      downloadurl: "",
      dialogVisible: false,
      UploadScreenVisible: false,
      publisherid: "",
      uploading: false,
      publisherinitiateid: "",
      pubidcontract: "",
      contractvisiblescreen: false,
      pubidforemail: "",
      searchvalue: "",
      contract: "",
      currentPage: 1,
      total_pages: 0,
      offset: 20,
      issearch: false,
      bankInfoScreenVisible: false,
      EditScreenVisible: false,
      bankDetail: "charmi shah",
      iscopied: false,
      editPubForm: {
        name: "",
        email: "",
        uuid: "",
        ownerid: "",
        amp_ss_enable: false,
      },
    };
  },
  created: function () {
    this.loadPublishers();
  },
  // watch: {
  //     publisher: function (newv,oldv) {
  //         oldv=newv;
  //         //console.log("@@watcher",newv,oldv);
  //     }
  // },
  methods: {
    copiedToClipboard() {
      console.log("iscopied", this.iscopied);
      this.iscopied = false;
      var elm = document.getElementById("divClipboard");
      // for Internet Explorer

      if (document.body.createTextRange) {
        var range = document.body.createTextRange();
        range.moveToElementText(elm);
        range.select();
        document.execCommand("Copy");
        // alert("Copied to Clipboard");
        this.iscopied = true;
      } else if (window.getSelection) {
        // other browsers

        var selection = window.getSelection();
        var range = document.createRange();
        range.selectNodeContents(elm);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand("Copy");
        this.iscopied = true;
        // alert("Copied to Clipboard");
      }
    },
    showBankInfoScreenVisiblefuncton(obj) {
      if (window.getSelection) {
        var selection = window.getSelection();
        selection.removeAllRanges();
      }
      this.iscopied = false;
      console.log("obj of bank detail", obj);
      this.bankInfoScreenVisible = true;
      this.bankDetail = obj.payment_details;
      if (Object.keys(this.bankDetail).length == 0) {
        this.bankDetail = "Bank details are not available”";
      }
    },

    closeBankInfoScreen() {
      this.bankInfoScreenVisible = false;
    },
    closeEditScreen() {
      this.EditScreenVisible = false;
    },
    showEditScreenVisiblefuncton(pubobj) {
      console.log("@@pubobj", pubobj);
      this.EditScreenVisible = true;

      this.editPubForm.name = pubobj.name;
      this.editPubForm.email = pubobj.contact_email;

      this.editPubForm.uuid = pubobj.uuid;
      this.editPubForm.ownerid = pubobj.owner_id;
      this.editPubForm.amp_ss_enable = pubobj.amp_ss_enable;
    },
    EditPublisher() {
      let self = this;
      var apiEditPub =
        BASE_URL + "v1/publishers/" + this.editPubForm.uuid + "/";
      let x = {
        name: this.editPubForm.name,
        contact_email: this.editPubForm.email,
        owner: this.editPubForm.ownerid,
        amp_ss_enable: this.editPubForm.amp_ss_enable,
      };
      axios
        .put(apiEditPub, x)
        .then((response) => {
          console.log("response", response.data.publisher_exists);
          if (response.data.publisher_exists == true) {
            this.$notify({
              title: "fail",
              message: "publisher already exist.",
              type: "fail",
            });
            return;
          } else {
            console.log("false part");
            this.userEdit();
          }
          this.loadPublishers(this.currentPage);
          this.$notify({
            title: "Success",
            message: "Publisher Updated successfully.",
            type: "success",
          });
          this.EditScreenVisible = false;
          setTimeout(() => {
            // this.$router.push('/admin/create-domain/?publisher='+response.data.id);
          }, 1000);
        })
        .catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Unable to update  publisher",
            type: "warning",
          });
        });
    },
    userEdit() {
      let self = this;
      console.log("calling pub uodate");
      let splitName = this.editPubForm.name.split(" "),
        firstName = splitName[0],
        lastName;
      if (splitName.length > 1) {
        splitName.shift();
        lastName = splitName.join(" ");
      } else lastName = splitName[0];
      axios
        .put(BASE_URL + "v1/users/" + this.editPubForm.ownerid + "/", {
          first_name: firstName,
          last_name: lastName,
          email: this.editPubForm.email,
        })
        .then((response) => {})
        .catch((error) => {
          this.$notify({
            title: "Warning",
            message: "Unable to update publisher",
            type: "warning",
          });
        });
    },

    handleCurrentChange(val) {
      //console.log("Current page#####################", val);
      this.currentPage = val;
      if (this.issearch) {
        this.filterByEachInput();
      } else {
        this.loadPublishers(val);
      }
    },
    filterByEachInput() {
      this.currentPage = 1;

      this.issearch = true;

      if (this.searchvalue.length == 0) {
        this.issearch = false;
        const apis = BASE_URL + `v1/publishers/?page=1&&offset=${this.offset}`;
        axios.get(apis).then((response) => {
          this.publisher = [];
          var dt = response.data.pub_data;
          this.publisher.push(...dt);
          this.total_pages = response.data.total;
        });

        return;
      }

      axios
        .get(
          `v1/search-publisher/?query=${this.searchvalue}&&page=${this.currentPage}&&offset=${this.offset}`
        )
        .then((response) => {
          var data = response.data.pub_data;
          this.publisher = [];
          this.publisher.push(...data);
          this.total_pages = response.data.total;
        });
    },
    confirmIntenttNividEmailSend(data) {
				this.$confirm('This service is intended only for External publishers live with Intentt. Yeti Pubs receive activation email with Contract. Continue?', 'Warning', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				type: 'warning'
				}).then(() => {
					console.log('pass')
					this.sendNividActivateEmail(data)
				}).catch(() => {
				this.$message({
					type: 'info',
					message: 'Action cancelled'
				});
				});
      },
    sendNividActivateEmail(obj){
      console.log("obj", obj);

      this.pubidforemail = obj.id;
      let em = obj.contact_email;
      let self = this;
      console.log({
          email: em,
          activateOrReset: "activate",
        })
      // return false
      axios
        .post(BASE_URL + "v1/auth/password/reset/nivid/", {
          email: em,
          activateOrReset: "activate",
        })
        .then((res) => {
          console.log("@@Res", res);
          self.$notify({
            title: "Success",
            message:
              "Email for Account Activation sent!",
            type: "success",
          });
          this.loadPublishers(this.currentPage);
          
        })
        .catch((e) => {
          this.uploading = false;
          self.$notify({
            title: "Fail",
            message: "Failed to send email of Account Activation.",
            type: "fail",
          });
        });
    },
    confirmSendWelcomeEmail(row){
      this.$confirm(row.welcome_mail_sent ? 'The contract and activation email have already been sent to the pub. Send again anyway?' : 'Yeti Pubs receive account activation email with Contract. Continue?', 'Warning', {
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				type: 'warning'
				}).then(() => {
					console.log('pass')
          this.sentemail(row)
				}).catch(() => {
          this.$message({
            type: 'info',
            message: 'Action cancelled'
          });
				});
    },
    sentemail(obj) {
      console.log("obj", obj);

      this.pubidforemail = obj.id;

      let em = obj.contact_email;
      let self = this;
      var api =
        BASE_URL + "v1/send-email-publisher/" + this.pubidforemail + "/";
      axios
        .post(BASE_URL + "v1/auth/password/reset/nivid/", {
          email: em,
          activateOrReset: "activate",
        })
        .then((res) => {
          console.log("@@Res", res);
          this.loadPublishers(this.currentPage);
        })
        .catch((e) => {
          this.uploading = false;
          self.$notify({
            title: "Fail",
            message: "Failed to send email of Account Activation.",
            type: "fail",
          });
        });

      axios
        .get(api)
        .then((response) => {
          //console.log("@@emailres", response);
          self.$notify({
            title: "Success",
            message:
              "Email of welcome publisher and Email for Account Activation successfully sent.",
            type: "success",
          });
        })
        .catch((e) => {
          this.uploading = false;
          self.$notify({
            title: "Fail",
            message: "Failed to send email of welcome publisher.",
            type: "fail",
          });
        });
    },
    dialogVisiblef(pubid) {
      this.publisherid = pubid;
      this.UploadScreenVisible = true;
    },

    dialogVisiblecontract(pubid) {
      this.pubidcontract = pubid;
      this.contractvisiblescreen = true;
    },
    cancelUploadAction: function () {
      this.$refs.file.clearFiles();
      this.contractvisiblescreen = false;
      this.UploadScreenVisible = false;
    },
    handleFileUpload(file) {
      this.taxFile = file.raw;
    },
    handleFileUploadcontract(file) {
      this.contract = file.raw;
    },
    submitcontract() {
      let self = this;
      var apic = BASE_URL + "v1/upload-contract/" + this.pubidcontract + "/";
      //console.log("this.taxFile.length", this.contract.length);
      if (this.contract.length == 0) {
        self.$notify({
          title: "Fail",
          message: "please select file before uploading",
          type: "Error",
        });
        return;
      }
      this.uploading = true;
      let formData = new FormData();
      formData.append("contract", this.contract);

      axios
        .post(apic, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          //console.log("res", response.data.signed_pdf);
          //console.log("tcp",this.currentPage);
          this.loadPublishers(this.currentPage);
          let obj = this.publisher.filter(
            (obj) => obj.id == this.pubidcontract
          );
          obj[0].contract_details.sign_pdf = response.data.signed_pdf;
          self.$notify({
            title: "Success",
            message: "uploaded  successfully.",
            type: "success",
          });
          this.contractvisiblescreen = false;
          this.contract = [];
          this.uploading = false;
          this.$refs.file.clearFiles();
        })
        .catch((e) => {
          this.uploading = false;
          self.$notify({
            title: "Fail",
            message: "uploaded  failed.",
            type: "fail",
          });
        });
    },
    submitFile() {
      let self = this;
      var api = BASE_URL + "v1/upload-tax-docs/" + this.publisherid + "/";
      if (this.taxFile.length == 0) {
        self.$notify({
          title: "Fail",
          message: "please select file before uploading",
          type: "Error",
        });
        return;
      }
      this.uploading = true;
      let formData = new FormData();
      formData.append("taxFile", this.taxFile);
      axios
        .post(api, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          self.$notify({
            title: "Success",
            message: "uploaded  successfully.",
            type: "success",
          });
          //console.log("tcp",this.currentPage);
          this.loadPublishers(this.currentPage);

          let obj = this.publisher.filter((obj) => obj.id == this.publisherid);
          obj[0].contract_details.tax_pdf = response.data.tax_pdf;

          this.UploadScreenVisible = false;
          this.taxFile = [];
          this.uploading = false;
          this.$refs.file.clearFiles();
        })
        .catch((e) => {
          this.uploading = false;
          self.$notify({
            title: "Fail",
            message: "uploaded  failed.",
            type: "fail",
          });
        });
    },
    clearFilesList: function () {
      this.$refs.file.clearFiles();
      this.UploadScreenVisible = false;
      this.contractvisiblescreen = false;
    },
    loadPublishers(pageNum) {
      //console.log("pagenum", pageNum);
      //console.log("hgghuhihiuh============", pageNum);
      if (pageNum == undefined) {
        pageNum = 1;
      }
      const api =
        BASE_URL + `v1/publishers/?page=${pageNum}&&offset=${this.offset}`;
      axios.get(api).then((response) => {
        //console.log("res", response);
        var data = response.data.pub_data;
        //console.log("dt", data);
        this.publisher = [];
        this.publisher.push(...data);

        var totalpg = response.data.total;
        this.total_pages = totalpg;
        //console.log("tolp", totalpg);
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// AllPublisher.vue?3ec6aac4